import * as React from "react";
import type { SVGProps } from "react";
const SvgPlusExtraSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.293 16.707A1 1 0 0 0 13 16v-3h3a1 1 0 0 0 0-2h-3V8a1 1 0 0 0-2 0v3H8a1 1 0 0 0 0 2h3v3a1 1 0 0 0 .293.707"
    />
  </svg>
);
export default SvgPlusExtraSmall;
